import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout";
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";
import store from "@/store";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);
// 路由入口，laotang
//=============學生系統路由 start=================//
const statusRoute = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/login/LoginBackstage.vue")
  },
  {
    path: "/app/sso/login",
    name: "ssoLogin",
    component: () => import("../views/app/sso/login.vue")
  },
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/newStu",
        name: "newStu",
        component: () => import("../views/backstage/NewStu.vue"),
        meta: {
          isPublic: true
        }
      },
      {
        path: "/oldStu",
        name: "oldStu",
        component: () => import("../views/backstage/OldStu.vue")
      },
      {
        path: "/apply",
        component: () => import("../views/backstage/Apply.vue"),
        name: "applicationForAccommodation",
        meta: {
          isPublic: true
        }
      },
      {
        path: "/applyOld",
        name: "applicationForAccommodationOld",
        component: () => import("../views/backstage/ApplyOld.vue")
      },
      {
        path: "/returnInNight",
        name: "returnInNight",
        component: () => import("../views/backstage/NightReturn.vue")
      },
      {
        path: "/hostelCheckoutReservation",
        name: "hostelCheckoutReservation",
        component: () => import("../views/backstage/Checkout.vue")
      },
      {
        path: "/overnight",
        name: "nightReturnRegistration",
        component: () => import("../views/backstage/Overnight.vue")
      }
    ]
  }
];

//=============學生系統路由 end=================//
//=============管理系統路由 start===============//
const ManagementRoutes = [
  {
    path: "/",
    name: "LoginB",
    component: () => import("../views/login/Login.vue")
  },
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/appointmentList",
        name: "guestAppointmentList",
        component: () => import("../views/guest/List.vue")
      },
      {
        path: "/appointment",
        name: "guestAppointment",
        component: () => import("../views/guest/Appointment.vue")
      },
      {
        path: "/backstage",
        name: "home"
      },
      {
        path: "/hotelExpense",
        name: "hotelExpense",
        component: () => import("../views/financial/HotelExpense.vue")
      },
      {
        path: "/preDistributionOfOldStudents",
        name: "preDistributionOfOldStudents",
        component: () => import("../views/dormitory/PreOldStudent.vue")
      },
      {
        path: "/preDistributionOfNewStudents",
        name: "preDistributionOfNewStudents",
        component: () => import("../views/dormitory/PreNewStudent.vue")
      },
      {
        path: "/dormitoryOvernight",
        name: "overnight",
        component: () => import("../views/dormitory/Overnight.vue")
      },
      {
        path: "/dormitoryList",
        name: "dormitoryList",
        component: () => import("../views/dormitory/DormitoryList.vue")
      },
      {
        path: "/dormitoryDiagram",
        name: "dormitoryDiagram",
        component: () => import("../views/dormitory/DormitoryDiagram.vue")
      },
      {
        path: "/checkOutApproval",
        name: "checkOutApproval",
        component: () => import("../views/dormitory/CheckOutApproval.vue")
      },
      {
        path: "/reportArrival",
        name: "arrival",
        component: () => import("../views/report/ArrivalReport.vue")
      },
      {
        path: "/reportBedChange",
        name: "bedChange",
        component: () => import("../views/report/BedChangeReport.vue")
      },
      {
        path: "/reportCheckIn",
        name: "checkIn",
        component: () => import("../views/report/CheckInReport.vue")
      },
      {
        path: "/reportPickup",
        name: "pickup",
        component: () => import("../views/report/PickUpServiceReport.vue")
      },
      {
        path: "/reportCheckOut",
        name: "checkOut",
        component: () => import("../views/report/CheckOutReport.vue")
      },
      {
        path: "/reportBed",
        name: "bed",
        component: () => import("../views/report/BedReport.vue")
      },
      {
        path: "/reportDeparture",
        name: "departure",
        component: () => import("../views/report/DepartureReport.vue")
      },
      {
        path: "/reportGuest",
        name: "guestReport",
        component: () => import("../views/report/GuestReport.vue")
      },
      {
        path: "/reportPayment",
        name: "payment",
        component: () => import("../views/report/PaymentReport.vue")
      },
      {
        path: "/reportCashier",
        name: "cashier",
        component: () => import("../views/report/CashierReport.vue")
      },
      {
        path: "/reportbedtagBalance",
        name: "bedtagBalance",
        component: () => import("../views/report/ReportbedtagBalance.vue")
      },
      {
        path: "/roleManagement",
        name: "roleManagement",
        component: () => import("../views/systemManagement/RolesManagement.vue")
      },
      {
        path: "/userManagement",
        name: "userManagement",
        component: () => import("../views/systemManagement/UserManagement.vue")
      },
      {
        path: "/dictionaryManagement",
        name: "dictionaryManagement",
        component: () =>
          import("../views/systemManagement/DictionaryManagement.vue")
      },
      {
        path: "/BedTagsManagement",
        name: "BedTagsManagement",
        component: () =>
          import("../views/systemManagement/BedTagsManagement.vue")
      },
      {
        path: "/templateManagement",
        name: "templateManagement",
        component: () =>
          import("../views/systemManagement/TemplateManagement.vue")
      },
      {
        path: "/roomManagement",
        name: "roomManagement",
        component: () => import("../views/systemManagement/RoomManagement.vue")
      },
      {
        path: "/parameterConfiguration",
        name: "parameterConfiguration",
        component: () => import("../views/systemManagement/ParamsConfig.vue")
      },
      {
        path: "/documentStudent",
        name: "documentStudent",
        component: () => import("../views/document/Student.vue")
      },
      {
        path: "/hostelApplyList",
        name: "hostelApplyList",
        component: () => import("../views/dormitory/HostelApplyList.vue")
      },
      {
        path: "/hostelCheckoutHistory",
        name: "hostelCheckoutHistory",
        component: () => import("../views/dormitory/HostelCheckOutHistory.vue")
      },
      {
        path: "/logViewer",
        name: "logViewer",
        component: () => import("../views/systemManagement/Log.vue")
      },
      {
        path: "/studentApplicationHistory",
        name: "studentApplicationHistory",
        component: () =>
          import("../views/dormitory/StudentApplicationHistory.vue")
      }
    ]
  }
  //=============管理系統路由 end===============//
];
// 下面為系統身份驗證公共部分路由
const commonRoutes = [
  {
    path: "/oidc-callback",
    name: "oidcCallback",
    component: () => import("../views/login/OidcCallback.vue"),
    meta: {
      isPublic: true
    },
    beforeEnter(to, from, next) {
      next();
    }
  },
  {
    path: "/oidc-popup-callback",
    name: "oidcPopupCallback",
    component: () => import("../views/login/OidcPopupCallback.vue"),
    meta: {
      isPublic: true
    }
  },
  {
    path: "/oidc-callback-error",
    name: "oidcCallbackError",
    component: () => import("../views/login/OidcCallbackError.vue"),
    meta: {
      isPublic: true
    }
  }
];
const routes = new Array();

// ManagementRoutes = {};
//=============系統路由開關=============== laotang//
for (var i = 0; i < statusRoute.length; i++) {
  routes.push(statusRoute[i]);
}
//for (var j = 0; j < ManagementRoutes.length; j++) {
//routes.push(ManagementRoutes[j]);
//}
for (var k = 0; k < commonRoutes.length; k++) {
  routes.push(commonRoutes[k]);
}

const router = new VueRouter({
  mode: "history",
  base: JSON.parse(localStorage.getItem("$myconfig")).publicPath,
  // base: process.env.BASE_URL,
  routes
});
let isUat = JSON.parse(localStorage.getItem("$myconfig")).isUat;
if (isUat !== "true") {
  router.beforeEach(vuexOidcCreateRouterMiddleware(store, "oidcStore"));
}
router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
export default router;
